
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
//-------------------------------------------
import Resize from "src/components/common/resize";
import { locatingItems } from "src/components/workLogs/optionalForms/locatingForm";
import { useMyStore } from "src/components/main/mainStore";
import {
    numberReducer, 
    onlyUnique, 
    myAxios, 
    projectCategoryColorCode, 
    MyFormData, 
    MyDate, 
    round, scroll, 
    arrayReducer, 
    exclusiveOutisdeKeys, 
    potholingReportWriterEmails, 
    locatingReportWriterEmails, 
    timeDurationCalc,
    appTitle, 
} from "src/components/common/functions";
import Chart from "./chart";
//-------------------------------------------
// this is for project stage color:
// 255, 99, 132 red
// 54, 162, 235 blue
// 255, 206, 86 yellow
// 75, 192, 192 green
// 153, 102, 255 purple
// 255, 159, 64 orange
// 127, 188, 65 grass green
// 50, 136, 189 dark blue
// 94, 79, 162 dark purple
//purchase category color 7 out of 9
//-------------------------------------------
export default function Dashboard({ tabTitle }){
    const locatingMap = Object.fromEntries(locatingItems.map(item => [item.title, item.showTitle]));
    const user = useMyStore(state => state.user);
    const convertTime = (start, end) => {
        if(start.substring(0, 10) === end.substring(0, 10)){
            //same day
            if(start.substring(11, 16) === "00:00" && end.substring(11, 16) === "00:00"){
                //all day
                return `${start.substring(0, 10)}`
            }else{
                return `${start.substring(0, 16)} - ${end.substring(11, 16)}`
            }
        }else{
            //overnight
            if(start.substring(11, 16) === "00:00" && end.substring(11, 16) === "00:00"){
                //all day
                return `${start.substring(0, 10)} - ${end.substring(0, 10)}`
            }else{
                return `${start.substring(0, 16)} - ${end.substring(0, 16)}`
            }
        }
    }
    //-------------------------------------------------------------------------
    const defaultSelectedDate = {
        start: `${(new Date()).getFullYear()}-${
            ((new Date()).getMonth() + 1) < 10?
            `0${(new Date()).getMonth() + 1}`
            :
            ((new Date()).getMonth() + 1)
        }-01`,
        end: (new MyDate()).s()
    }
    const categoryList = Object.entries(projectCategoryColorCode).map(([key, value]) => ({
        title: value.title, 
        value: key, 
        rgb: value.rgb
    }));
    const inRange = (dateStr) => dateStr >= userSelectedDate.start && dateStr < `${userSelectedDate.end} 24:59:99`;
    const opt = [
        {value: "Work In Progress", rgb: [255, 99, 132]}, 
        {value: "Report Deliverable", rgb: [54, 162, 235]}, 
        {value: "Invoice", rgb: [255, 206, 86]}, 
        {value: "Received Payment", rgb: [75, 192, 192]}, 
        {value: "Progress Payment", rgb: [94, 79, 162]}, 
        {value: "Permits", rgb: [153, 102, 255]}, 
        {value: "USA Delineation", rgb: [255, 159, 64]}, 
        {value: "Schedule Field Work", rgb: [127, 188, 65]}, 
        {value: "Traffic Control Plans", rgb: [50, 136, 189]}
    ];
    //-------------------------------------------------------------------------
    const [userSelectedDate, setUserSelectedDate] = useState(defaultSelectedDate);
    const [showLoading, setShowLoading] = useState(false);
    const [workLogs, setWorkLogs] = useState([]);
    const [jobTags, setJobTags] = useState([]);
    const [scheduledProjects, setScheduledProjects] = useState([]);
    const [updatedWorkInstructions, setUpdatedWorkInstructions] = useState([]);
    const [purchases, setPurchases] = useState([]);
    const [users, setUsers] = useState([]);
    // const [timeCards, setTimeCards] = useState([]);
    const [curReports, setReports] = useState({});
    const usersMap = Object.fromEntries(users.map(user => [user.email, `${user.userName}`]));
    const [userList, setUserList] = useState([]);
    const [curUser, setCurUser] = useState();
    const [open, setOpen] = useState("");
    const [potholing, setPotholing] = useState({});
    const [sc, setSc] = useState({});
    const [locating, setLocating] = useState({});
    const [cctv, setCCTV] = useState({});
    const [start, setStart] = useState("");
    const [end, setEnd] = useState("");
    //-------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async() => {
            const formData = new MyFormData();
            formData.append("start", userSelectedDate.start);
            formData.append("end", userSelectedDate.end);
            //--------------------------------------------------------
            setShowLoading(true);
            const res = await myAxios("reports/x.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            const locatingArr = [];
            const potholingArr = [];
            // const ordered = 
            res.data.timeCards.forEach(u => Object.keys(u).sort().reduce(
                (obj, key) => {
                    if(exclusiveOutisdeKeys.includes(key)){
                        obj[key] = u[key];
                        return obj;
                    }
                    obj[key] = u[key]?
                        {
                            ...JSON.parse(u[key]), 
                            email: obj.email
                        }
                        :
                        {
                            form: Array(7).fill({inOut: [], notes: ""}), 
                            email: obj.email, 
                            status: "Created"
                        }
                    ;
                    if(obj[key].status !== "Created"){
                        if(locatingReportWriterEmails.includes(obj[key].email)){
                            locatingArr.push(...obj[key].form.filter(f => f.inOut.length));
                        }
                        if(potholingReportWriterEmails.includes(obj[key].email)){
                            potholingArr.push(...obj[key].form.filter(f => f.inOut.length));
                        }
                    }
                    return obj;
                }, 
                {}
            ));
            // console.log(ordered);
            // setTimeCards(ordered);

            const locatingReport = locatingArr.map(l => l.inOut).reduce(arrayReducer, []).filter(io => io.reports).map(io => io.reports).reduce(arrayReducer, []);
            const locatingReportNumber = locatingReport.map(l => l.reportHashKey).filter(onlyUnique).length;
            const locatingReportHours = (locatingReport.map(l => timeDurationCalc(l.start, l.end)).reduce(numberReducer, 0) / 60).toFixed(2);
            
            const potholingReport = potholingArr.map(l => l.inOut).reduce(arrayReducer, []).filter(io => io.reports).map(io => io.reports).reduce(arrayReducer, []);
            const potholingReportNumber = potholingReport.map(l => l.reportHashKey).filter(onlyUnique).length;
            const potholingReportHours = (potholingReport.map(l => timeDurationCalc(l.start, l.end)).reduce(numberReducer, 0) / 60).toFixed(2);
            
            setReports({locatingReportNumber, locatingReportHours, potholingReportNumber, potholingReportHours});
            //--------------------------------------------------------
            // const projects = res.data.projects; // $statusChangedProjects
            // const extra = res.data.workInstructions.filter((w, i, wi) => !projects.map(p => p.projectHashKey).includes(w.projectHashKey) && wi.map(x => x.projectHashKey).indexOf(w.projectHashKey) === i);
            // setProjects([...res.data.projects, ...extra]);
            // setWorkInstructions(res.data.workInstructions);
            const thisScheduledProjects = (res.data.workInstructions.filter((value, index, array) => (array.map(project => project.projectHashKey).indexOf(value.projectHashKey) === index)));
            setScheduledProjects(thisScheduledProjects);
            setUpdatedWorkInstructions(res.data.workInstructions);
            setWorkLogs(res.data.workLogs);
            setJobTags(res.data.jobTags.map(jT => ({...jT, hours: ((new Date(jT.travelEndTime.replace(/-/, "/")) - new Date(jT.travelStartTime.replace(/-/, "/"))) / 3600000)})));
            const dataSheets = res.data.workLogs;
            if(dataSheets.length){
                setSc({
                    scanningCoring: dataSheets.filter(d => d.laborCategory === "GPR & Concrete Scaning & Coring").length,
                    scanning: dataSheets.filter(d => d.laborCategory === "GPR & Concrete Scanning").length,
                    coring: dataSheets.filter(d => d.laborCategory === "GPR & Concrete Coring").length
                });
                const forms = dataSheets.map(d => JSON.parse(d.forms)).reduce(arrayReducer, []);
                const defaultCCTV = {
                    "Completed Lateral Footage (ft)": "0",
                    "Completed Linear Footage (ft)": "0",
                    "Total Sewer Footage Mark / Locate (ft)": "0",
                    "Total Storm Footage Mark / Locate (ft)": "0"
                };
                const reduceFunc0 = (a, b) => {
                    const obj = {};
                    for(let key in defaultCCTV){
                        obj[key] = window.Number.parseFloat(a[key] || "0") + window.Number.parseFloat(b[key] || "0");
                    }
                    return obj;
                }
                const curCCTV = forms.filter(d => d.form === "CCTV Form").map(d => JSON.parse(d.content)).reduce((a, b) => reduceFunc0(a, b), defaultCCTV);
                setCCTV(curCCTV);
                const defaultLocating = 
                {
                    "White (ft)": "0",
                    "Pink (ft)": "0",
                    "Red (ft)": "0",
                    "Yellow (ft)": "0",
                    "Orange (ft)": "0",
                    "Blue (ft)": "0",
                    "Purple (ft)": "0",
                    "Green (ft)": "0",
                    "Total (ft)": "0"
                };
                const reduceFunc = (a, b) => {
                    const obj = {};
                    for(let key in defaultLocating){
                        obj[key] = window.Number.parseFloat(a[key] || "0") + window.Number.parseFloat(b[key] || "0");
                    }
                    return obj;
                }
                const curLocating = forms.filter(d => d.form === "Locating Form").map(d => JSON.parse(d.content)).reduce((a, b) => reduceFunc(a, b), defaultLocating);
                curLocating["Total (ft)"] = Object.values(curLocating).reduce((aa, bb) => window.Number.parseFloat(aa) + window.Number.parseFloat(bb));
                setLocating(curLocating);
                setPotholing({
                    pothole: dataSheets.map(d => JSON.parse(d.potholingForm)).reduce(arrayReducer, []).filter(d => d.cancel !== "Yes").length,
                    cancelPothole: dataSheets.map(d => JSON.parse(d.potholingForm)).reduce(arrayReducer, []).filter(d => d.cancel === "Yes").length,
                    manhole: forms.filter(d => d.form === "Manhole Form" && d.cancel !== "Yes").length,
                    cancelManhole: forms.filter(d => d.form === "Manhole Form" && d.cancel === "Yes").length,
                    electric: forms.filter(d => d.form === "Electric Pothole Form" && d.cancel !== "Yes").length,
                    cancelElectric: forms.filter(d => d.form === "Electric Pothole Form" && d.cancel === "Yes").length
                });
            }else{
                setPotholing({
                    pothole: 0,
                    manhole: 0,
                    electric: 0
                });
            }
            setUsers(res.data.users);
            setPurchases(res.data.purchases);
            const workInstructionCreatorList = res.data.workInstructions.filter(w => inRange(w.workInstructionCreationDate)).map(w => w.workInstructionCreatorEmail);
            const workInstructionUpdatorList = res.data.workInstructions.filter(w => w.workInstructionDateUpdated && inRange(w.workInstructionDateUpdated)).map(w => w.workInstructionUpdaterEmail);
            const projectCreatorList = thisScheduledProjects.filter(p => inRange(p.projectCreationDate)).map(p => p.projectCreatorEmail);
            const projectUpdatorList = thisScheduledProjects.filter(p => p.projectDateUpdated && inRange(p.projectDateUpdated)).map(p => p.projectUpdaterEmail);
            const purchaseCreatorList = res.data.purchases.filter(pu => inRange(pu.submitTime)).map(pu => pu.submitterEmail);
            const purchaseUpdaterList = res.data.purchases.filter(pu => pu.dateUpdated !== pu.submitTime && inRange(pu.dateUpdated)).map(pu => pu.updaterEmail);
            const curUserList = [
                ...purchaseCreatorList, 
                ...purchaseUpdaterList, 
                ...workInstructionCreatorList, 
                ...projectCreatorList, 
                ...workInstructionUpdatorList, 
                ...projectUpdatorList
            ].filter(onlyUnique);
            setUserList(curUserList);
        }
        getData();
        return () => {isMounted = false;}
    }, [userSelectedDate])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //-------------------------------------------------------------------------
    return (
    <div>
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    Dashboard
                </span>
                <span></span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "start" className = "mb-0">Start:</label>
                    <input
                        id = "start"
                        type = "date"
                        min = "1900-01-01"
                        max = {(new MyDate()).s() || "2999-12-31"}
                        className = "form-control w-auto ml-2"
                        value = {start}
                        onChange = {e => setStart(e.currentTarget.value)}
                        name = "start"
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "end" className = "mb-0">End:</label>
                    <input
                        id = "end"
                        type = "date"
                        min = "1900-01-01"
                        max = {(new MyDate()).s() || "2999-12-31"}
                        className = "form-control w-auto ml-2"
                        value = {end}
                        onChange = {e => setEnd(e.currentTarget.value)}
                        name = "end"
                    />
                </span>
                {userSelectedDate.start !== start || userSelectedDate.end !== end?
                <span
                    className = "pointer"
                    onClick = {() => {
                        if(start === ""){
                            window.alert("Start can not be empty.");
                            return
                        }
                        if(end === ""){
                            window.alert("End can not be empty.");
                            return
                        }
                        if(userSelectedDate.start === start && userSelectedDate.end === end){
                            return;
                        }
                        if(new Date(start?.replace(/-/g, "/")) <= new Date(end?.replace(/-/g, "/"))){
                            setUserSelectedDate({start: start, end: end})    
                        }else{
                            window.alert("Start date is greater than end date.");
                            return;
                        }
                    }}
                >
                    Load
                </span>:<></>}
            </div>
            <div className = "cssContent pb10">
            {showLoading?<div className = "cssLoading">Loading...</div>:
            <>
            <div className = "py-4">
                <div>
                    <span
                        className = {`pointer${open === "projects"?" rounded bg-primary text-white py-1 px-2":""} m-4`}
                        onClick = {() => {
                            if(open === "projects"){
                                setOpen("");
                            }else{
                                setOpen("projects");
                            }
                            scroll(null);
                        }}
                    >Projects</span>
                </div>
                {open === "projects"?
                <>
                <div className = "charts">
                    <Chart 
                        width = "91%"
                        chartConfig = {{
                            type: "bar",
                            data: {
                                labels: categoryList.map(category => category.title),
                                datasets: 
                                opt.map(o => ({
                                    label: o.value,
                                    data: categoryList.map(category => scheduledProjects.filter(p => p.stage === o.value && p.pipeline === category.value).length),
                                    backgroundColor: `rgba(${o.rgb.join(", ")}, 0.5)`,
                                    borderColor: `rgba(${o.rgb.join(", ")}, 1)`,
                                    borderWidth: 1
                                }))
                            },
                            options: {
                                title: {
                                    fontSize: 20,
                                    display: true, 
                                    text: "Secheduled Projects Status"
                                },
                                scales: {
                                    xAxes: [{
                                        stacked: true, 
                                        scaleLabel: {
                                            fontSize: 15,
                                            display: true,
                                            labelString: "Project Category"
                                        },
                                    }],
                                    yAxes: [{
                                        stacked: true, 
                                        ticks: {
                                            beginAtZero: true 
                                        },
                                        scaleLabel: {
                                            fontSize: 15,
                                            display: true,
                                            labelString: "Number of Projects"
                                        },
                                    }]
                                }
                            }
                        }}
                    />
                </div>
                <div className = "charts">
                    <Chart 
                        width = "91%"
                        chartConfig = {{
                            type: "bar",
                            data: {
                                labels: categoryList.map(category => category.title),
                                datasets: 
                                [{
                                    backgroundColor: categoryList.map(category => `rgba(${projectCategoryColorCode[category.value].rgb.join(", ")}, 0.5)`),
                                    borderColor: categoryList.map(category => `rgba(${projectCategoryColorCode[category.value].rgb.join(", ")}, 1)`),
                                    data: categoryList.map(category => (updatedWorkInstructions.filter(wI => wI.category === category.value).length))
                                }]
                            },
                            options: {
                                legend: {
                                    display: false
                                },
                                title: {
                                    fontSize: 20,
                                    display: true, 
                                    text: "Work Instructions Status"
                                },
                                scales: {
                                    xAxes: [{
                                        stacked: true, 
                                        scaleLabel: {
                                            fontSize: 15,
                                            display: true,
                                            labelString: "Project Category"
                                        },
                                    }],
                                    yAxes: [{
                                        stacked: true, 
                                        ticks: {
                                            beginAtZero: true 
                                        },
                                        scaleLabel: {
                                            fontSize: 15,
                                            display: true,
                                            labelString: "Number of Work Instructions"
                                        },
                                    }]
                                }
                            }
                        }}
                    />
                </div>
                <div className = "charts">
                    <Chart 
                        width = "91%"
                        chartConfig = {{
                            type: "bar",
                            data: {
                                labels: categoryList.map(category => category.title),
                                datasets: 
                                [{
                                    backgroundColor: categoryList.map(category => `rgba(${projectCategoryColorCode[category.value].rgb.join(", ")}, 0.5)`),
                                    borderColor: categoryList.map(category => `rgba(${projectCategoryColorCode[category.value].rgb.join(", ")}, 1)`),
                                    data: categoryList.map(category => (workLogs.filter(wL => wL.category === category.value).length))
                                }]
                            },
                            options: {
                                legend: {
                                    display: false
                                },
                                title: {
                                    fontSize: 20,
                                    display: true, 
                                    text: "Work Logs Status"
                                },
                                scales: {
                                    xAxes: [{
                                        stacked: true, 
                                        scaleLabel: {
                                            fontSize: 15,
                                            display: true,
                                            labelString: "Project Category"
                                        },
                                    }],
                                    yAxes: [{
                                        stacked: true, 
                                        ticks: {
                                            beginAtZero: true 
                                        },
                                        scaleLabel: {
                                            fontSize: 15,
                                            display: true,
                                            labelString: "Number of Work Logs"
                                        },
                                    }]
                                }
                            }
                        }}
                    />
                </div>
                <div className = "charts">
                    <Chart 
                        width = "91%"
                        chartConfig = {{
                            type: "bar",
                            data: {
                                labels: categoryList.map(category => category.title),
                                datasets: 
                                [{
                                    backgroundColor: categoryList.map(category => `rgba(${projectCategoryColorCode[category.value].rgb.join(", ")}, 0.5)`),
                                    borderColor: categoryList.map(category => `rgba(${projectCategoryColorCode[category.value].rgb.join(", ")}, 1)`),
                                    data: categoryList.map(category => (jobTags.filter(jT => jT.category === category.value).map(jT => jT.hours).reduce(numberReducer, 0).toFixed(2)))
                                }]
                            },
                            options: {
                                legend: {
                                    display: false
                                },
                                title: {
                                    fontSize: 20,
                                    display: true, 
                                    text: "Labor Hours Status"
                                },
                                scales: {
                                    xAxes: [{
                                        stacked: true, 
                                        scaleLabel: {
                                            fontSize: 15,
                                            display: true,
                                            labelString: "Project Category"
                                        },
                                    }],
                                    yAxes: [{
                                        stacked: true, 
                                        ticks: {
                                            beginAtZero: true 
                                        },
                                        scaleLabel: {
                                            fontSize: 15,
                                            display: true,
                                            labelString: "Number of Labor Hours"
                                        },
                                    }]
                                }
                            }
                        }}
                    />
                </div>
            <div className = "d-flex">
            {
                [
                    {chartTitle: "Projects", allData: scheduledProjects, text: `Projects Status`},
                    {chartTitle: "Work Instructions", allData: updatedWorkInstructions, text: `Work Instructions Created By Project Category`}
                ].map((elem, i) => 
                <div key = {i} className = "flex-grow-1">
                    <Chart 
                        chartConfig = {{
                            type: "doughnut",
                            data: {
                                labels: categoryList.map(category => category.title),
                                datasets: [{
                                    data: categoryList.map(category => elem.allData.filter(items => items[elem.chartTitle === "Projects"?"pipeline":"category"] === category.value).length),
                                    backgroundColor: categoryList.map(category => `rgba(${category.rgb.join(", ")}, 0.5)`),
                                    borderColor: categoryList.map(category => `rgba(${category.rgb.join(", ")}, 1)`),
                                    borderWidth: 1
                                }]
                            },
                            options: {
                                title: {
                                    fontSize: 20,
                                    display: true,
                                    text: elem.text
                                }
                            }
                        }}
                    />
                    <div className = "ml-5 mt-4">Number of {elem.chartTitle}:</div>
                    <div className = "d-flex ml-5 mt-4">
                        {categoryList.map((category, categoryi) =>
                        <details key = {categoryi} className = "my-2 mr-3">
                            <summary>
                                {category.title}: {elem.allData.filter(w => w[elem.chartTitle === "Projects"?"pipeline":"category"] === category.value).length}
                            </summary>
                            {elem.allData.filter(w => w[elem.chartTitle === "Projects"?"pipeline":"category"] === category.value).length?
                            <div>
                                <ul>
                                {elem.allData.filter(w => w[elem.chartTitle === "Projects"?"pipeline":"category"] === category.value).map(w => w.stage).filter(onlyUnique).map((stage, stagei) => <li key = {stagei}><details>
                                    <summary>{stage} {elem.allData.filter(w => w[elem.chartTitle === "Projects"?"pipeline":"category"] === category.value && w.stage === stage).length}</summary>
                                <ul>
                                    {elem.allData.filter(w => w[elem.chartTitle === "Projects"?"pipeline":"category"] === category.value && w.stage === stage).map((w, wi) => <li key = {wi}>
                                        <Link to = {`/Projects/${w.projectHashKey}${elem.chartTitle === "Work Instructions"?`/WorkInstructions/${w.workInstructionHashKey}`:""}`}>
                                            {w.projectName}
                                            {elem.chartTitle === "Work Instructions"?
                                            <span className = "text-success ml-2">{convertTime(w.startTime, w.endTime)}</span>
                                            :null
                                            }
                                        </Link>
                                    </li>)}
                                </ul>
                                </details></li>)
                                }
                                </ul>
                            </div>
                            :null}
                        </details>
                        )}
                    </div>
                </div>)
            }</div>
            <div className = "ml-5 mt-4">
                <h5>Potholing</h5>
                <ul>
                    <li>Number of Potholes: {potholing.pothole}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Canceled: {potholing.cancelPothole}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Total: {potholing.pothole + potholing.cancelPothole}</li>
                    <li>Number of Manholes: {potholing.manhole}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Canceled: {potholing.cancelManhole}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Total: {potholing.manhole + potholing.cancelManhole}</li>
                    <li>Number of Electric Potholes: {potholing.electric}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Canceled: {potholing.cancelElectric}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Total: {potholing.electric + potholing.cancelElectric}</li>
                </ul>
            </div>
            <div className = "ml-5 mt-4">
                <h5>Locating</h5>
                <ul>
                {Object.entries(locating).map((entry, entryIndex) => <li key = {entryIndex}>
                    {locatingMap[entry[0]] ?? entry[0]}: {entry[1]}
                </li>)}
                </ul>
            </div>
            <div className = "ml-5 mt-4">
                <h5>CCTV</h5>
                <ul>
                    {Object.entries(cctv).map((entry, entryIndex) => <li key = {entryIndex}>
                        {entry[0]}: {entry[1]}
                    </li>)}
                </ul>
            </div>
            <div className = "ml-5 mt-4">
                <h5>GPR & Concrete Scanning and Coring</h5>
                <ul>
                    <li>Scanning & Coring: {sc.scanningCoring}</li>
                    <li>Scanning: {sc.scanning}</li>
                    <li>Coring: {sc.coring}</li>
                </ul>
            </div>
            <div className = "ml-5 mt-4">
                <h5>Report Tech</h5>
                <ul>
                    <li>
                        Locating
                        <ul>
                            <li>Reports: {curReports.locatingReportNumber}</li>
                            <li>Hours: {curReports.locatingReportHours}</li>
                        </ul>
                    </li>
                    
                    <li>
                        Potholing
                        <ul>
                            <li>Reports: {curReports.potholingReportNumber}</li>
                            <li>Hours: {curReports.potholingReportHours}</li>
                        </ul>
                    </li>
                </ul>
            </div>
            </>:null}
            </div>
            <div className = "pb-4">
                <div>
                    <span className = {`pointer${open === "purchases"?" rounded bg-primary text-white py-1 px-2":""} m-4`} onClick = {() => {
                        if(open === "purchases"){
                            setOpen("");
                        }else{
                            setOpen("purchases");
                        }
                        scroll(null);
                    }}>Purchases</span>
                </div>
                {open === "purchases"?
                <>
                <div className = "charts">
                    <Chart 
                        width = "91%"
                        chartConfig = {{
                            type: "bar",
                            data: {
                                labels: purchases.map(p => p.department).filter(onlyUnique),
                                datasets: purchases.map(p => p.category).filter(onlyUnique).map((category, categoryi) => 
                                    ({   
                                        data:purchases.map(p => p.department).filter(onlyUnique)
                                        .map(department => 
                                            purchases.filter(p => p.department === department && p.category === category)
                                            .map(p => round(p.total, 2)).reduce(numberReducer, 0)
                                        ),
                                        label: category,
                                        backgroundColor: `rgba(${opt[categoryi]?.rgb.join(", ")}, 0.5)`,
                                        borderColor: `rgba(${opt[categoryi]?.rgb.join(", ")}, 1)`,
                                        fill: false
                                    })
                                )
                            },
                            options: {
                                legend: {
                                    display: true
                                },
                                title: {
                                    fontSize: 20,
                                    display: true, 
                                    text: "Purchases Status"
                                },
                                scales: {
                                    xAxes: [{
                                        stacked: true, 
                                        scaleLabel: {
                                            fontSize: 15,
                                            display: true,
                                            labelString: "Purchases Department"
                                        }
                                    }],
                                    yAxes: [{
                                        stacked: true, 
                                        ticks: {
                                            beginAtZero: true 
                                        },
                                        scaleLabel: {
                                            fontSize: 15,
                                            display: true,
                                            labelString: "Total Dollar Amount of POs Created"
                                        }
                                    }]
                                } 
                            }
                        }}
                    />
                </div>
                <div className = "ml-5 mt-4">Number of POs Created:</div>
                <div className = "ml-5 mt-4 d-flex">
                    {purchases.map(p => p.department).filter(onlyUnique).map((department, departmenti) =>
                    <details key = {departmenti} className = "my-2 mr-3">
                        <summary>
                            {department}: {purchases.filter(w => 
                                w.department === department).length
                            } (${
                                purchases.filter(w => w.department === department)
                                .map(p => round(p.total, 2)).reduce(numberReducer, 0)
                            })
                        </summary>
                        {purchases.find(w => w.department === department)?
                        <div>
                            <ul>
                                {purchases.filter(w => w.department === department).map(p => p.category).filter(onlyUnique).map((category, categoryi) => <li key = {categoryi}><details>
                                <summary>{category} {purchases.filter(w => w.department === department && w.category === category).length} (${
                                purchases.filter(w => w.department === department && w.category === category)
                                .map(p => round(p.total, 2)).reduce(numberReducer, 0)
                            })</summary>
                                <ul>
                                    {purchases.filter(w => w.department === department && w.category === category).map((w, wi) => <li key = {wi}>
                                        <Link to = {`/Purchases/${w.poNumber}`}>
                                            <span>{w.poNumber}</span>
                                            <span className = "text-success ml-2">${w.total}</span>
                                        </Link>
                                    </li>)}
                                </ul>
                                </details>
                                </li>
                                )}
                            </ul>
                        </div>
                        :null}
                    </details>
                    )}
                </div>
                </>:null}
            </div>
            <div className = "pb-4">
                <div>
                    <span className = {`pointer${open === "users"?" rounded bg-primary text-white py-1 px-2":""} m-4`} onClick = {() => {
                        if(open === "users"){
                            setOpen("");
                        }else{
                            setOpen("users");
                        }
                        scroll(null);
                    }}>User Activities</span>
                </div>
                {open === "users"?
                <div className = "mt-5 ml-5">
                    <div>
                        <span className = "mr-3 font-weight-bold">User:</span>
                        <select
                            className = "form-control inline font-weight-bold"
                            value = {curUser}
                            onChange = {e => {
                                setCurUser(e.currentTarget.value);
                            }}
                        >
                            <option className = "font-weight-bold" value = "">Select</option>
                            {userList.map((u, i) => 
                            <option
                                key = {i}
                                className = "font-weight-bold"
                                value = {u}
                            >
                                {usersMap[u]}
                            </option>)}
                        </select>
                    </div>
                    {curUser?<>
                    <div className = "mt-4">
                        {scheduledProjects.find(p => p.projectCreatorEmail === curUser && inRange(p.projectCreationDate))?
                        <details className = "my-2">
                            <summary>
                                Number of Projects Created: {scheduledProjects.filter(p => p.projectCreatorEmail === curUser && inRange(p.projectCreationDate)).length}
                            </summary>
                            <div>
                                <Chart 
                                    width = "91%"
                                    chartConfig = {{
                                        type: "line",
                                        data: {
                                            labels: scheduledProjects.filter(p => p.projectCreatorEmail === curUser && inRange(p.projectCreationDate)).map(p => p.projectCreationDate.slice(0, 10)).filter(onlyUnique).sort().map(dateStr => new Date(dateStr.replace("-", "/"))),
                                            datasets: [{
                                                tension: 0,
                                                fill: false, 
                                                borderColor: "rgb(75, 192, 192)", 
                                                data: scheduledProjects.filter(p => p.projectCreatorEmail === curUser && inRange(p.projectCreationDate)).map(p => p.projectCreationDate.slice(0, 10)).filter(onlyUnique).sort()
                                                .map(d => scheduledProjects.filter(p => p.projectCreatorEmail === curUser && inRange(p.projectCreationDate) && p.projectCreationDate.slice(0, 10) === d).length)
                                            }],
                                        }, 
                                        options: {
                                            legend: {
                                                display: false
                                            },
                                            title: {
                                                fontSize: 20,
                                                display: true, 
                                                text: "Number of Projects Created"
                                            },
                                            scales: {
                                                xAxes: [{
                                                    type: "time",
                                                    time: {
                                                        unit: "day"
                                                    },
                                                    stacked: true, 
                                                    scaleLabel: {
                                                        fontSize: 15,
                                                        display: true,
                                                        labelString: "Date"
                                                    },
                                                }],
                                                yAxes: [{
                                                    stacked: true, 
                                                    ticks: {
                                                        stepSize: 1,
                                                        beginAtZero: true 
                                                    }
                                                }]
                                            }
                                        }
                                    }}
                                />
                            </div>
                            <div>
                                <ul>
                                    {scheduledProjects.filter(p => p.projectCreatorEmail === curUser && inRange(p.projectCreationDate)).map((p, pi) => <li key = {pi}>
                                    <Link to = {`/Projects/${p.projectHashKey}`}>
                                        <span>{p.projectName}</span>
                                        <span className = "ml-2 text-info">{p.pipeline}</span>
                                        <span className = "ml-2 text-success">{p.stage}</span>
                                    </Link></li>)}
                                </ul>
                            </div>
                        </details>
                        :<></>}
                        {scheduledProjects.find(p => p.projectUpdaterEmail === curUser && p.projectDateUpdated && inRange(p.projectDateUpdated))?
                        <details className = "my-2">
                            <summary>
                                Number of Projects Updated: {scheduledProjects.filter(p => p.projectUpdaterEmail === curUser && p.projectDateUpdated && inRange(p.projectDateUpdated)).length}
                            </summary>
                            <div>
                                <Chart 
                                    width = "91%"
                                    chartConfig = {{
                                        type: "line",
                                        data: {
                                            labels: scheduledProjects.filter(p => p.projectUpdaterEmail === curUser && p.projectDateUpdated && inRange(p.projectDateUpdated)).map(p => p.projectDateUpdated.slice(0, 10)).filter(onlyUnique).sort().map(dateStr => new Date(dateStr.replace("-", "/"))),
                                            datasets: [{
                                                tension: 0,
                                                fill: false, 
                                                borderColor: "rgb(75, 192, 192)", 
                                                data: scheduledProjects.filter(p => p.projectUpdaterEmail === curUser && p.projectDateUpdated && inRange(p.projectDateUpdated)).map(p => p.projectDateUpdated.slice(0, 10)).filter(onlyUnique).sort()
                                                .map(d => scheduledProjects.filter(p => p.projectUpdaterEmail === curUser && p.projectDateUpdated && inRange(p.projectDateUpdated) && p.projectDateUpdated.slice(0, 10) === d).length)
                                            }],
                                        }, 
                                        options: {
                                            legend: {
                                                display: false
                                            },
                                            title: {
                                                fontSize: 20,
                                                display: true, 
                                                text: "Number of Projects Updated"
                                            },
                                            scales: {
                                                xAxes: [{
                                                    type: "time",
                                                    time: {
                                                        unit: "day"
                                                    },
                                                    stacked: true, 
                                                    scaleLabel: {
                                                        fontSize: 15,
                                                        display: true,
                                                        labelString: "Date"
                                                    },
                                                }],
                                                yAxes: [{
                                                    stacked: true, 
                                                    ticks: {
                                                        stepSize: 1,
                                                        beginAtZero: true 
                                                    }
                                                }]
                                            }
                                        }
                                    }}
                                />
                            </div>
                            <div>
                                <ul>
                                    {scheduledProjects.filter(p => p.projectUpdaterEmail === curUser && p.projectDateUpdated && inRange(p.projectDateUpdated)).map((p, pi) => <li key = {pi}>
                                    <Link to = {`/Projects/${p.projectHashKey}`}>
                                        <span>{p.projectName}</span>
                                        <span className = "ml-2 text-info">{p.pipeline}</span>
                                        <span className = "ml-2 text-success">{p.stage}</span>
                                    </Link></li>)}
                                </ul>
                            </div>
                        </details>
                        :<></>}
                        {updatedWorkInstructions.find(w => w.workInstructionCreatorEmail === curUser && inRange(w.workInstructionCreationDate))?
                        <details className = "my-2">
                            <summary>
                                Number of Work Instructions Created: {updatedWorkInstructions.filter(w => w.workInstructionCreatorEmail === curUser && inRange(w.workInstructionCreationDate)).length}
                            </summary>
                            <div>
                                <Chart 
                                    width = "91%"
                                    chartConfig = {{
                                        type: "line",
                                        data: {
                                            labels: updatedWorkInstructions.filter(w => w.workInstructionCreatorEmail === curUser && inRange(w.workInstructionCreationDate)).map(w => w.workInstructionCreationDate.slice(0, 10)).filter(onlyUnique).sort().map(dateStr => new Date(dateStr.replace("-", "/"))),
                                            datasets: [{
                                                tension: 0,
                                                fill: false, 
                                                borderColor: "rgb(75, 192, 192)", 
                                                data: updatedWorkInstructions.filter(w => w.workInstructionCreatorEmail === curUser && inRange(w.workInstructionCreationDate)).map(w => w.workInstructionCreationDate.slice(0, 10)).filter(onlyUnique).sort()
                                                .map(d => updatedWorkInstructions.filter(w => w.workInstructionCreatorEmail === curUser && inRange(w.workInstructionCreationDate) && w.workInstructionCreationDate.slice(0, 10) === d).length)
                                            }],
                                        }, 
                                        options: {
                                            legend: {
                                                display: false
                                            },
                                            title: {
                                                fontSize: 20,
                                                display: true, 
                                                text: "Number of Work Instructions Updated"
                                            },
                                            scales: {
                                                xAxes: [{
                                                    type: "time",
                                                    time: {
                                                        unit: "day"
                                                    },
                                                    stacked: true, 
                                                    scaleLabel: {
                                                        fontSize: 15,
                                                        display: true,
                                                        labelString: "Date"
                                                    },
                                                }],
                                                yAxes: [{
                                                    stacked: true, 
                                                    ticks: {
                                                        stepSize: 1,
                                                        beginAtZero: true 
                                                    }
                                                }]
                                            }
                                        }
                                    }}
                                />
                            </div>
                            <div>
                                <ul>
                                    {updatedWorkInstructions.filter(w => w.workInstructionCreatorEmail === curUser && inRange(w.workInstructionCreationDate)).map((w, wi) => <li key = {wi}>
                                        <Link to = {`/Projects/${w.projectHashKey}/WorkInstructions/${w.workInstructionHashKey}`}>
                                            <span>{w.projectName}</span>
                                            <span className = "ml-2 text-primary">{convertTime(w.startTime, w.endTime)}</span>
                                            <span className = "ml-2 text-info">{w.pipeline}</span>
                                            <span className = "ml-2 text-success">{w.stage}</span>
                                    </Link></li>)}
                                </ul>
                            </div>
                        </details>
                        :<></>}
                        {updatedWorkInstructions.find(w => w.workInstructionUpdaterEmail === curUser && w.workInstructionDateUpdated && inRange(w.workInstructionDateUpdated))?
                        <details className = "my-2">
                            <summary>
                                Number of Work Instructions Updated: {updatedWorkInstructions.filter(w => w.workInstructionUpdaterEmail === curUser && w.workInstructionDateUpdated && inRange(w.workInstructionDateUpdated)).length}
                            </summary>
                            <div>
                                <Chart 
                                    width = "91%"
                                    chartConfig = {{
                                        type: "line",
                                        data: {
                                            labels: updatedWorkInstructions.filter(w => w.workInstructionUpdaterEmail === curUser && w.workInstructionDateUpdated && inRange(w.workInstructionDateUpdated)).map(w => w.workInstructionDateUpdated.slice(0, 10)).filter(onlyUnique).sort().map(dateStr => new Date(dateStr.replace("-", "/"))),
                                            datasets: [{
                                                tension: 0,
                                                fill: false, 
                                                borderColor: "rgb(75, 192, 192)", 
                                                data: updatedWorkInstructions.filter(w => w.workInstructionUpdaterEmail === curUser && w.workInstructionDateUpdated && inRange(w.workInstructionDateUpdated)).map(w => w.workInstructionDateUpdated.slice(0, 10)).filter(onlyUnique).sort()
                                                .map(d => updatedWorkInstructions.filter(w => w.workInstructionUpdaterEmail === curUser && w.workInstructionDateUpdated && inRange(w.workInstructionDateUpdated) && w.workInstructionDateUpdated.slice(0, 10) === d).length)
                                            }],
                                        }, 
                                        options: {
                                            legend: {
                                                display: false
                                            },
                                            title: {
                                                fontSize: 20,
                                                display: true, 
                                                text: "Number of Work Instructions Updated"
                                            },
                                            scales: {
                                                xAxes: [{
                                                    type: "time",
                                                    time: {
                                                        unit: "day"
                                                    },
                                                    stacked: true, 
                                                    scaleLabel: {
                                                        fontSize: 15,
                                                        display: true,
                                                        labelString: "Date"
                                                    },
                                                }],
                                                yAxes: [{
                                                    stacked: true, 
                                                    ticks: {
                                                        stepSize: 1,
                                                        beginAtZero: true 
                                                    }
                                                }]
                                            }
                                        }
                                    }}
                                />
                            </div>
                            <div>
                                <ul>
                                    {updatedWorkInstructions.filter(w => w.workInstructionUpdaterEmail === curUser && w.workInstructionDateUpdated && inRange(w.workInstructionDateUpdated)).map((w, wi) => <li key = {wi}>
                                    <Link to = {`/Projects/${w.projectHashKey}/WorkInstructions/${w.workInstructionHashKey}`}>
                                        <span>{w.projectName}</span>
                                        <span className = "ml-2 text-primary">{convertTime(w.startTime, w.endTime)}</span>
                                        <span className = "ml-2 text-info">{w.pipeline}</span>
                                        <span className = "ml-2 text-success">{w.stage}</span>
                                    </Link></li>)}
                                </ul>
                            </div>
                        </details>
                        :<></>}
                        {purchases.find(pu => pu.submitterEmail === curUser && inRange(pu.submitTime))?
                        <details className = "my-2">
                            <summary>
                                Number of POs Created: {purchases.filter(pu => pu.submitterEmail === curUser && inRange(pu.submitTime)).length}
                            </summary>
                            <div>
                                <Chart 
                                    width = "91%"
                                    chartConfig = {{
                                        type: "line",
                                        data: {
                                            labels: purchases.filter(pu => pu.submitterEmail === curUser && inRange(pu.submitTime)).map(pu => pu.submitTime.slice(0, 10)).filter(onlyUnique).sort().map(dateStr => new Date(dateStr.replace("-", "/"))),
                                            datasets: [{
                                                tension: 0,
                                                fill: false, 
                                                borderColor: "rgb(75, 192, 192)", 
                                                data: purchases.filter(pu => pu.submitterEmail === curUser && inRange(pu.submitTime)).map(pu => pu.submitTime.slice(0, 10)).filter(onlyUnique).sort()
                                                .map(d => purchases.filter(pu => pu.submitterEmail === curUser && inRange(pu.submitTime) && pu.submitTime.slice(0, 10) === d).length)
                                            }],
                                        }, 
                                        options: {
                                            legend: {
                                                display: false
                                            },
                                            title: {
                                                fontSize: 20,
                                                display: true, 
                                                text: "Number of POs Created"
                                            },
                                            scales: {
                                                xAxes: [{
                                                    type: "time",
                                                    time: {
                                                        unit: "day"
                                                    },
                                                    stacked: true, 
                                                    scaleLabel: {
                                                        fontSize: 15,
                                                        display: true,
                                                        labelString: "Date"
                                                    },
                                                }],
                                                yAxes: [{
                                                    stacked: true, 
                                                    ticks: {
                                                        stepSize: 1,
                                                        beginAtZero: true 
                                                    }
                                                }]
                                            }
                                        }
                                    }}
                                />
                            </div>
                            <div>
                                <ul>
                                    {purchases.filter(pu => pu.submitterEmail === curUser && inRange(pu.submitTime)).map((pu, pui) => <li key = {pui}>
                                        <Link to = {`/Purchases/${pu.poNumber}`}>
                                            <span>{pu.poNumber}</span>
                                            <span className = "ml-2 text-primary">${pu.total}</span>
                                            <span className = "ml-2 text-info">{pu.department}</span>
                                            <span className = "ml-2 text-success">{pu.category}</span>
                                        </Link></li>)}
                                </ul>
                            </div>
                        </details>
                        :<></>}
                        {purchases.find(pu => pu.updaterEmail === curUser && pu.submitTime !== pu.dateUpdated && inRange(pu.dateUpdated))?
                        <details className = "my-2">
                            <summary>
                                Number of POs Updated: {purchases.filter(pu => pu.updaterEmail === curUser && pu.submitTime !== pu.dateUpdated && inRange(pu.dateUpdated)).length}
                            </summary>
                            <div>
                                <Chart 
                                    width = "91%"
                                    chartConfig = {{
                                        type: "line",
                                        data: {
                                            labels: purchases.filter(pu => pu.updaterEmail === curUser && pu.submitTime !== pu.dateUpdated && inRange(pu.dateUpdated)).map(pu => pu.dateUpdated.slice(0, 10)).filter(onlyUnique).sort().map(dateStr => new Date(dateStr.replace("-", "/"))),
                                            datasets: [{
                                                tension: 0,
                                                fill: false, 
                                                borderColor: "rgb(75, 192, 192)", 
                                                data: purchases.filter(pu => pu.updaterEmail === curUser && pu.submitTime !== pu.dateUpdated && inRange(pu.dateUpdated)).map(pu => pu.dateUpdated.slice(0, 10)).filter(onlyUnique).sort()
                                                .map(d => purchases.filter(pu => pu.updaterEmail === curUser && pu.submitTime !== pu.dateUpdated && inRange(pu.dateUpdated) && pu.dateUpdated.slice(0, 10) === d).length)
                                            }],
                                        }, 
                                        options: {
                                            legend: {
                                                display: false
                                            },
                                            title: {
                                                fontSize: 20,
                                                display: true, 
                                                text: "Number of POs Created"
                                            },
                                            scales: {
                                                xAxes: [{
                                                    type: "time",
                                                    time: {
                                                        unit: "day"
                                                    },
                                                    stacked: true, 
                                                    scaleLabel: {
                                                        fontSize: 15,
                                                        display: true,
                                                        labelString: "Date"
                                                    },
                                                }],
                                                yAxes: [{
                                                    stacked: true, 
                                                    ticks: {
                                                        stepSize: 1,
                                                        beginAtZero: true 
                                                    }
                                                }]
                                            }
                                        }
                                    }}
                                />
                            </div>
                            <div>
                                <ul>
                                    {purchases.filter(pu => pu.updaterEmail === curUser && pu.submitTime !== pu.dateUpdated && inRange(pu.dateUpdated)).map((pu, pui) => <li key = {pui}>
                                        <Link to = {`/Purchases/${pu.poNumber}`}>
                                            <span>{pu.poNumber}</span>
                                            <span className = "ml-2 text-primary">${pu.total}</span>
                                            <span className = "ml-2 text-info">{pu.department}</span>
                                            <span className = "ml-2 text-success">{pu.category}</span>
                                    </Link></li>)}
                                </ul>
                            </div>
                        </details>
                        :<></>}
                    </div>
                    </>:null}
                </div>:null}
            </div>
            </>}
            </div>
        </div>    
    </div>
    )
}